import React from "react";
import "./IconLauncher.css";
import LaunchTile from "./LaunchTile/LaunchTile";

const IconLauncher = ({ widget }) => {
  return (
    <div className="icon-launcher-main">
      <label
        className="overflow-ellipsis ng_sh_sb"
        title={widget?.config?.name}
      >
        {widget?.config?.name}
      </label>
      <div>
        {widget.config.launcherItems.map((config) => (
          <LaunchTile key={config?.id} config={config} />
        ))}
      </div>
    </div>
  );
};

export default IconLauncher;
